import Chat from "@tencent/plive-msg"
import "@tencent/plive-msg/lib/style.css"
import { useEffect, useMemo, useState } from "react"
import { TypeDoc, TypeInfo } from "../../App"
import { useBasicStore } from "../../store"
import SuperPlayer from "../console-player"
import { SendGiftBar } from "../send_gift_bar/send_gift_bar"
import "./virtual_man.scss"

export type TimParam = {
  groupId: string
  sdkAppId: number
  userId: string
  userSig: string
}

const messageConfig: any = {
  isShowTime: false,
  isShowRead: true,
  showAvatar: "none",
  showName: "in", // 本人不展示昵称
  showHeader: 0,
  plugin: {
    config: {
      quote: {
        isShow: false,
      },
      forward: {
        isShow: false,
      },
      revoke: {
        isShow: false,
      },
      delete: {
        isShow: false,
      },
      copy: {
        isShow: false,
      },
    },
  },
}

const videoIconUrl =
  "https://cloudcache.tencent-cloud.com/qcloud/ui/static/tc_portal_icon/f35ea39e-88bc-4184-bbeb-ab0cdff4ec0d.png"

export function VirtualMan({ info }: { info: TypeInfo }) {
  const [timParam, setTimParam] = useState({} as TimParam)
  const [recommendText, setRecommendText] = useState("") // 当前用户输入的文案

  const [getBasicInfo, playUrl] = useBasicStore((state: any) => [
    state.getBasicInfo,
    info?.PlayUseProtocol === "webrtc" ? state.PlayURLs[3] : state.PlayURLs[1],
  ])

  // 拼接字幕等参数后的播放url
  const wholePlayUrl = useMemo(() => {
    let url = playUrl
    if (!url) {
      return ""
    }
    // 以http开头的，调整为https开头
    if (url.startsWith("http") && !url.includes("https")) {
      url = url.replace("http", "https")
    }
    if (url.endsWith("?")) {
      return `${url}${info?.PlayUrlExtParam}`
    }
    return `${url}&${info?.PlayUrlExtParam}`
  }, [playUrl, info?.PlayUrlExtParam])

  console.log(timParam, "wholePlayUrl")

  function renderList(ite: TypeDoc) {
    return (
      <div className="recommend_bg">
        <img
          src={ite.IconUrl ?? videoIconUrl}
          width={32}
          height={32}
          alt="icon"
        ></img>
        <span className="recommend_text" onClick={() => window.open(ite.Link)}>
          {ite.Title}
        </span>
      </div>
    )
  }
  // 渲染文档列表
  const genRecommendList = useMemo(() => {
    if (!info.BannerInfoList) {
      throw new Error("没有文档列表")
    }

    const { MatchBannerList, DefaultBannerList } = info.BannerInfoList
    // 1. 返回默认文档列表：没有关键词、待匹配关键词列表为空
    if (!recommendText || !MatchBannerList?.length) {
      if (!DefaultBannerList?.length) {
        return null
      }
      return DefaultBannerList.map((ite) => renderList(ite))
    }
    // 2. 根据用户输入内容返回推荐文档列表
    const res: any[] = []
    MatchBannerList.filter(
      (ite) =>
        recommendText.includes(ite?.KeyWord) &&
        ite.BannerList.map((ite) => res.push(ite)),
    )

    // 2.1 筛选不到符合要求的关键词，返回默认文档列表
    if (!res.length) {
      return DefaultBannerList.map((ite) => renderList(ite))
    }
    // 2.2 筛选到符合要求的关键词，返回推荐文档列表
    // 2.2.1 res不够五条，从默认里补充够5条
    if (res.length < 5) {
      const defaultList = [...DefaultBannerList.slice(0, 5 - res.length)]
      return defaultList.concat(res).map((ite) => renderList(ite))
    }
    // 2.2.2 res够五条，直接返回
    return res.map((ite) => renderList(ite))
  }, [recommendText, info.BannerInfoList])

  function getMyMessage(message: any) {
    setRecommendText(message?.payload?.text)
  }

  useEffect(() => {
    if (!info?.ElvbRoomId) {
      return
    }
    getBasicInfo({ RoomId: info?.ElvbRoomId, Type: 1 }).then((res: any) => {
      const { IMToken, IMGroupId, IMSDKAppid, username } = res
      setTimParam({
        groupId: IMGroupId,
        sdkAppId: IMSDKAppid,
        userId: username,
        userSig: IMToken,
      })
    })
  }, [info?.ElvbRoomId])

  return (
    <div className="virtual_modal_body_outer">
      <div className="virtual_modal_body_main">
        <SuperPlayer
          url={wholePlayUrl}
          ctrlbar={false}
          style={{ width: 880, height: 497 }}
        />
        <div className="virtual_chat_outer" style={{ paddingLeft: 8 }}>
          <Chat
            messageConfig={messageConfig}
            timParam={timParam}
            lng="zh"
            liveLink={wholePlayUrl}
            className="container_chat"
            input={{
              placeholderText: "请输入您想咨询的问题...",
              isLike: true,
            }}
            getMyMessage={getMyMessage}
            name={"云直播数字人产品经理"}
          />
        </div>
      </div>
      {/* ai动效礼物发送栏目 */}
      <div className="virtual_modal_body_outer__footer">
        <SendGiftBar live_url={wholePlayUrl} />
      </div>
      {/* 推荐文档 */}
      <div className="virtual_recommend_outer">{genRecommendList}</div>
    </div>
  )
}
